export function mandateBookingPath(m) {
  const q = new URLSearchParams();
  if (m?.advisor_id) q.set("with", m.advisor_id);
  q.set("duration", String(m?.meeting_duration_min || 60));
  q.set("freq", m?.meeting_frequency || "weekly");
  if (m?.title) q.set("title", m.title);
  if (m?.start_date) q.set("start", m.start_date);
  if (m?.total_amount_cents) {
    q.set("rate", String(m.total_amount_cents / 100));
    q.set("currency", m.currency || "CAD");
  }
  return `/app/sessions/new?${q.toString()}`;
}
